/**
 * A series of matrices to use with filter().
 * See: ./index.js @ filter() for more info
 */

// Classic sepia using values modified from Microsoft's recommended
// sepia filter
export const SEPIA_FILTER = [
  [0.343, 0.719, 0.139],
  [0.299, 0.636, 0.118],
  [0.222, 0.484, 0.081],
];

// dream filter
export const DREAM_FILTER = [
  [0.323, 0.699, 0.119],
  [0.1, 0.616, 0.098],
  [1.0, 0.464, 0.661],
];

// Kind of purpleish
export const SPOOKY_FILTER = [
  [0.323, 0.699, 0.119],
  [0.279, 0.616, 0.098],
  [0.202, 0.464, 0.661],
];

// Kind of blueish for the workshop
export const WORKSHOP_FILTER = [
  [0, 0, 0],
  [0, 0.7, 0],
  [0.1, 0.5, 0.5],
];

// Green-blue
export const BIRD_FILTER = [
  [1, 0, 0],
  [0, 1.1, 0],
  [1.2, -1.1, 0.9],
];

// Orange-yellow
export const CAT_FILTER = [
  [1, 1.7, 0.8],
  [0.2, 0.7, 0],
  [0, -1.4, 0.7],
];

// Blue
export const BEAST_FILTER = [
  [1.3, -0.5, 0.4],
  [0, 1, -0.1],
  [0, 0, 1.2],
];

// This is a saturation filter
export const SOFT_VIBRANT_FILTER = [
  [1.35, 0, 0],
  [0, 1.15, 0],
  [0, 0, 1],
];

// This is a more intense saturation filter
export const HARSH_VIBRANT_FILTER = [
  [1.55, 0, 0],
  [0, 1.35, 0],
  [0, 0, 1],
];

// Does not alter color palette
export const NEUTRAL_FILTER = [
  [1, 0, 0],
  [0, 1, 0],
  [0, 0, 1],
];

export const WARM_LIGHTS = [
  [1.2, 0, 1.1],
  [0, 1.1, 0.2],
  [0.2, 0, 0.9],
];

export const WARM_CURIOSO = [
  [0, 1, 1],
  [0.9, 0.7, 0],
  [0.5, 0, 0.2],
];

export const WARM_BOOK = [
  [1, 1.5, 1],
  [0.5, 1, -0.4],
  [0, 0, 0.5],
];

export const COOL_CURIOSO = [
  [1, 0, 0],
  [0, 1.1, 0],
  [0, 0, 1.2],
];

export const COOL_BOOK = [
  [1, 0, 0],
  [0, 1, 0],
  [1, 1, 0.5],
];

export const COOL_LIGHTS = [
  [0.3, 0.4, 0],
  [-0.2, 1.6, 0],
  [0, 1, 1.3],
];

export const BW_LIGHTS = [
  [0, 1.3, 0],
  [0, 1.3, 0],
  [0, 1.5, 0.5],
];

export const PURPLE_CURIOSO = [
  [1, 0.7, 0],
  [0, 0.8, 0],
  [0, 0.6, 1],
];

export const PURPLE_BOOK = [
  [0.6, 1, -0.3],
  [0, 1, 0],
  [0, 1, 1],
];

export const GREEN_CURIOSO = [
  [1.4, 0.2, 0],
  [0.8, 0.9, 0],
  [0, -0.5, 0.5],
];

export const GREEN_BOOK = [
  [1, 0.5, 0],
  [0.3, 1.1, 0],
  [1, -1, 1],
];

export const GOLDEN_LIGHTS = [
  [1, 1, 0.3],
  [0.8, 0.8, 0],
  [0, 0, 0.5],
];
